import React, { Component } from 'react';
import { Card, Icon, Timeline } from 'antd';
import moment from 'moment-timezone';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

@inject('store')
@withRouter
@observer
export class JournalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logs: []
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.logs && nextProps.position) {
            this.logs = this.props.store.botStore.positionStore.getPositionLogs(
                nextProps.position.id,
                logs => {
                    this.setState({ logs });
                }
            );
        }
    }

    componentWillUnmount() {
        this.logs && this.logs();
    }

    render() {
        const position = this.props.position;

        if (!position) return null;

        const timezone = this.props.store.userStore.currentUser.timezone;

        return (
            <Card title={`Journal: ${position.id}`} bordered={false} size={'small'}>
                <Timeline>
                    {this.state.logs.map((item, i) => {
                        return (
                            <Timeline.Item
                                dot={this.getIcon(item.service, item.message)}
                                color={item.error ? '#ba7272' : '#436b45'}
                                key={i}
                            >
                                {item.message}{' '}
                                {moment(item.date)
                                    .tz(timezone)
                                    .format('MMMM Do YYYY, h:mm:ss a')}
                            </Timeline.Item>
                        );
                    })}
                </Timeline>
            </Card>
        );
    }

    getIcon(service, message) {
        if (!service) {
            const m = message.toLowerCase();

            if (m.indexOf('buy') >= 0) {
                return <i className="fal fa-arrow-up success" />;
            }
            if (m.indexOf('sell') >= 0) {
                return <i className="fal fa-arrow-down error" />;
            }
            if (m.indexOf('sold') >= 0) {
                return <i className="fal fa-arrow-down error" />;
            }
            if (m.indexOf('creating') >= 0) {
                return <i className="fal fa-flag info" />;
            }

            return null;
        }

        switch (service) {
            case 'art':
                return <Icon type="fund" style={{ fontSize: '16px', color: '#a187ff' }} />;
            default:
                return <Icon type={service} style={{ fontSize: '16px', color: '#a187ff' }} />;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionView/JournalDetails.js